//vue-toasted  面包屑提示 用法：在组件中this.$toasted.global.pop_warning('***')

import Toasted from 'vue-toasted'
import Vue from 'vue'
import router from '../router'

let SHOW_ERROR = true, SHOW_WARNING = true, SHOW_DEBUG = false

Vue.use(Toasted, {
  router
})

//my error options to the toast
let errorOptions = {
  position: 'bottom-right',
  duration: 5000,
  type: 'error',
  theme: 'bubble',
  iconPack: 'fontawesome',
  icon: 'exclamation-triangle',
  className: 'error_toast',
  containerClass: 'error_toast_container'
}

// register the toast with the custom message
Vue.toasted.register('pop_error',
  (payload) => {
    if (SHOW_ERROR) {
      // if there is no message passed show default message
      if (!payload) {
        return '未知的错误'
      }
      // if there is a message show it with the message
      return payload
    }
  },
  errorOptions
)

let infoOptions = {
  position: 'bottom-right',
  duration: 5000,
  type: 'info',
  theme: 'bubble',
  iconPack: 'fontawesome',
  icon: 'paper-plane',
  className: 'info_toast',
  containerClass: 'info_toast_container'
}

// register the toast with the custom message
Vue.toasted.register('pop_info',
  (payload) => {

    // if there is no message passed show default message
    if (!payload) {
      return '未定义的消息'
    }

    // if there is a message show it with the message
    return payload
  },
  infoOptions
)

let warningOptions = {
  position: 'bottom-right',
  duration: 5000,
  type: 'error',
  theme: 'bubble',
  iconPack: 'fontawesome',
  icon: 'exclamation-triangle',
  className: 'warning_toast',
  containerClass: 'warning_toast_container'
}

// register the toast with the custom message
Vue.toasted.register('pop_warning',
  (payload) => {
    if (SHOW_WARNING) {
      // if there is no message passed show default message
      if (!payload) {

        return ''
      }

      // if there is a message show it with the message
      return payload
    }
  },
  warningOptions
)

let successOptions = {
  position: 'bottom-right',
  duration: 5000,
  type: 'success',
  theme: 'bubble',
  iconPack: 'fontawesome',
  icon: 'check',
  className: 'success_toast',
  containerClass: 'success_toast_container'
}

// register the toast with the custom message
Vue.toasted.register('pop_success',
  (payload) => {

    // if there is no message passed show default message
    if (!payload) {
      return ''
    }

    // if there is a message show it with the message
    return payload
  },
  successOptions
)

//console.log
Object.defineProperty(Vue.prototype, '$debug', {
  value: function (title = '', info) {
    if (SHOW_DEBUG) {
      if (typeof info == 'object') {
        info = JSON.stringify(info, null, 4)
      }
      console.log('Debug: ' + title, info)
    }
  }
})
